import { initNavigation }        from './modules/navigation.js';
import { initCountup }           from './modules/countup.js';
import { initReveal }            from './modules/reveal.js';
import { initPrograms }          from './modules/programs.js';
import { initGoldTabs }          from './modules/gold-tabs.js';
import { initTimeline }          from './modules/timeline.js';
import { initKbFix }             from './modules/kb-fix.js';
import { initSideNav }           from './modules/side-nav.js';
import { initSmallCardCarousel } from './modules/small-card-carousel.js';
import { initProblemAccordion }  from './modules/problem-accordion.js';
import { initPackageDetails }    from './modules/package-details.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initReveal();
  initCountup();
  initPrograms();
  initGoldTabs();
  initTimeline();
  initKbFix();
  initSideNav();
  initSmallCardCarousel();
  initProblemAccordion();
  initPackageDetails();
});
